import { CartService, CartServiceModule } from '@b2b/common/services';
import { ApiService } from '@b2b/common/services/api/types';
import { UIBModalService } from '@b2b/types/core';
import { Maybe, TODO } from '@b2b/types/core/utils';
import { Organization } from '@b2b/types/organization';
import angular, { IFilterService, IRootScopeService, IScope } from 'angular';

interface CartItemEventScopeModel {
  event: TODO;
  reservationError: TODO;
  hasTicketError: TODO;
  restrictedEventError: TODO;
  ticket: TODO;
  memberTicketLimitMap: TODO;
  ticketLimitGroups: TODO;
  tickets: TODO;
  eventId: TODO;
  addOns: TODO;
  limitsChecked: TODO;
  hasLimits: TODO;
  hasSalesRuleRestriction: TODO;
  ignoreLimits: TODO;
}

CartItemEventDirective.$inject = [];

function CartItemEventDirective() {
  CartItemEventController.$inject = [
    '$scope',
    '$rootScope',
    '$filter',
    '$uibModal',
    'CartService',
    'CalendarService',
    'UserPreferencesService',
    'ApiService',
    'HelpersService',
    'SalesRulesService',
  ];

  function CartItemEventController(
    $scope: IScope & { cartItemEvent: TODO; model: CartItemEventScopeModel },
    $rootScope: IRootScopeService,
    $filter: IFilterService,
    $uibModal: UIBModalService,
    CartService: CartService,
    CalendarService: TODO,
    UserPreferencesService: TODO,
    ApiService: ApiService,
    HelpersService: TODO,
    SalesRulesService: TODO
  ) {
    const ctrl = {
      cartService: CartService,
      organization: undefined as Maybe<Partial<Organization>>,
      submitting: false,
      errors: [] as {
        message: string;
        details?: { errorText: string }[];
      }[],

      eventDate: false as string | false,

      eventTimes: [],
      availableEventTimes: [] as TODO[],
      selectedEventTime: false as { id: number } | false,
      selectedTicketType: false as { ticketingTypeId: number } | false,
      selectedAddOn: false as { inventoryId: number } | false,

      priceOptions: [
        {
          name: 'membership',
          label: 'Discounted',
          enabled: false,
        },
        {
          name: 'retail',
          label: 'Full Price',
          enabled: true,
        },
      ],
      selectedPriceOption: null as string | null,

      standardTime: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),

      isMemberCheckout: false,
      isDiscounted: false,

      entitlementsLoading: false,
      eventTimesLoading: false,

      text: {
        eventSalesLimit: 'Ticket limit: ',
        eventSalesLimitInCart: 'Ticket limit: ',
      },

      init: function () {
        const model = $scope.model;
        ctrl.eventDate = CalendarService.parseDate(model.event.startTime);
        ctrl.selectedPriceOption = ctrl.priceOptions[1].name;
        ctrl.refresh();

        $scope.$on('$destroy', $scope.$watch('model.reservationError', ctrl.validate));
        $scope.$on('$destroy', $scope.$watch('model.hasTicketError', ctrl.validate));
        $scope.$on('$destroy', $scope.$watch('model.restrictedEventError', ctrl.validate));
        $scope.$on('$destroy', $scope.$watch('model.event', ctrl.refresh));
        $scope.$on('$destroy', $scope.$watch('cartItemEvent.cartService.organization', ctrl.onCartOrganizationUpdate));
        $scope.$on('UserPreferencesService:onDateFormatLoad', ctrl.onDateFormatLoad);
        $scope.$on('Sum::UpdateTotal', ctrl.onSumUpdateTotal);
      },

      getEventTimes: function () {
        const model = $scope.model;
        const props = HelpersService.getPaginator();
        const startDate = new Date(ctrl.eventDate as TODO);
        const endDate = new Date(ctrl.eventDate as TODO);

        if (!ctrl.eventTimesLoading) {
          ctrl.eventTimesLoading = true;
          props.templateId = model.event.templateId;
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(23, 59, 59, 999);

          props.startTime = CalendarService.toISO8601(startDate);
          props.endTime = CalendarService.toISO8601(endDate);
          ApiService.program.instances.times
            .list(props)
            .then(ctrl.success.getEventTimes)
            .catch(ctrl.error.getEventTimes);
        }
      },

      refresh: function () {
        ctrl.getRemainingPrices();
        ctrl.getRemainingAddons();
        if (!ctrl.eventTimes.length) {
          ctrl.getEventTimes();
        } else {
          ctrl.availableEventTimes = ctrl.processEventTimes(ctrl.eventTimes);
          ctrl.validate();
        }
        ctrl.checkDiscounts();
      },

      checkDiscounts: function () {
        let membership = CartService.getTransactingMembership();

        if (membership) {
          ctrl.setMemberCheckout();
        } else {
          // This may be a new membership in the cart, so let's check that as well
          membership = CartService.getTransactingMembershipCategory();
          if (membership) {
            ctrl.setMemberCheckout();
          } else {
            ctrl.resetMemberCheckout(false);
          }
        }
      },

      setTicketLimits: function () {
        const model = $scope.model;
        const limits = {};
        let isViolation = false;
        const ticketsQuantity = SalesRulesService.getTicketsQuantities(model.tickets);
        const groupQuantity = SalesRulesService.getGroupQuantity(model);

        if (model.hasOwnProperty('memberTicketLimitMap') && !model.memberTicketLimitMap.hasSalesRuleRestriction) {
          angular.forEach(model.ticketLimitGroups, function (limitGroup, id) {
            angular.forEach(limitGroup.regular.groups, function (group) {
              let ticketsCounter = 0;

              // limits per ticket
              limits[id] = group.groupMax;

              if (!group.isPreventRule) {
                isViolation = true;
              }

              // limits for 2+ ticket types
              if (!group.isPreventRule) {
                angular.forEach(group.violation.ticketTypeIds, function (ticketTypeId) {
                  if (id !== ticketTypeId) {
                    angular.forEach(ticketsQuantity, function (quantity, ticketsQuantityId) {
                      if (ticketsQuantityId === ticketTypeId) {
                        limits[id] -= quantity;
                      }
                    });

                    if (limits[id] < 0) {
                      limits[id] = 0;
                    }
                  }
                });

                // prevent rules
              } else {
                // prevent for 1 ticket type
                if (group.violation.ticketTypeId && ticketsQuantity[group.violation.ticketTypeId] > limits[id]) {
                  angular.forEach(group.violation.validatedTicketTypeIds, function (validatedTicketTypeId) {
                    if (
                      validatedTicketTypeId !== group.violation.ticketTypeId &&
                      ticketsQuantity[validatedTicketTypeId] > 0
                    ) {
                      limits[validatedTicketTypeId] = 0;
                      isViolation = true;
                    }
                  });
                }

                // prevents for +2 ticket types
                if (group.violation.ticketTypeIds.length) {
                  limits[id] = group.violation.maxLimit;
                  angular.forEach(group.violation.ticketTypeIds, function (ticketTypeId) {
                    angular.forEach(ticketsQuantity, function (quantity, ticketsQuantityId) {
                      if (id !== ticketTypeId && ticketTypeId === ticketsQuantityId) {
                        limits[id] -= quantity;
                      }

                      if (ticketTypeId === ticketsQuantityId) {
                        ticketsCounter += quantity;
                      }
                    });

                    if (limits[id] < 0) {
                      limits[id] = 0;
                    }
                  });

                  if (ticketsCounter > group.violation.maxLimit) {
                    angular.forEach(group.violation.validatedTicketTypeIds, function (validatedTicketTypeId) {
                      if (
                        group.violation.ticketTypeIds.indexOf(validatedTicketTypeId) < 0 &&
                        ticketsQuantity[validatedTicketTypeId] > 0
                      ) {
                        isViolation = true;
                      }
                    });
                  }
                }
              }
            });
          });
        } else {
          angular.forEach(model.memberTicketLimitMap, function (limitGroup, id) {
            // limit and prevent rules on previous purchases
            if (limitGroup.hasOwnProperty('regular') && limitGroup.regular.remaining !== null) {
              limits[id] = limitGroup.regular.inCartLimit ? limitGroup.regular.limit : limitGroup.regular.remaining;
              isViolation = true;
            }
          });
        }

        angular.forEach(model.tickets, function (ticket, index) {
          if (limits.hasOwnProperty(ticket.ticketingTypeId) && isViolation) {
            model.tickets[index].maxLimit = limits[ticket.ticketingTypeId];
          } else {
            model.tickets[index].maxLimit = model.event.capacity;
          }
          model.tickets[index].groupQuantity = groupQuantity[ticket.ticketingTypeId];
        });
      },

      resetMemberCheckout: function (resetEventMembershipDetail) {
        const model = $scope.model;

        if (resetEventMembershipDetail) {
          ctrl.cartService.events.setEventMembershipDetail(model.eventId, []);
        }

        ctrl.selectedPriceOption = ctrl.priceOptions[1].name;
        ctrl.isMemberCheckout = false;
        ctrl.isDiscounted = false;
        ctrl.setMemberPriceOption(false);
      },

      setMemberCheckout: function () {
        const model = $scope.model;
        ctrl.isMemberCheckout = ctrl.cartService.isMemberCart();

        if (ctrl.isMemberCheckout) {
          ctrl.setMemberPriceOption(true);
        }

        ctrl.isDiscounted = ctrl.cartService.events.isEventDiscounted(model);

        if (!ctrl.isDiscounted) {
          CartService.events
            .removeDiscountedTickets(model)
            .then((response) => {
              $scope.$emit('OrderItem::Remove');
            })
            .catch((response) => {
              $scope.$emit('OrderItem::Remove::Error', response.data.error);
            });
        }
      },

      isTicketDiscounted: function (ticket) {
        const model = $scope.model;
        return ctrl.cartService.events.isTicketDiscounted(ticket, model);
      },

      isTicketDiscountedWithCoupon: function (ticket) {
        const model = $scope.model;
        return ctrl.cartService.events.isTicketDiscountedWithCoupon(ticket, model);
      },

      getEventTicketCount: function (discounted) {
        let result: string | number = '';

        if (discounted) {
          result = ctrl.getDiscountedEventTicketCount() || '';
        } else {
          result = ctrl.getFullPriceEventTicketCount() || '';
        }

        return result;
      },

      getDiscountedEventTicketCount: function () {
        const model = $scope.model;
        return ctrl.cartService.events.getDiscountedEventTicketCount(model.eventId);
      },

      getFullPriceEventTicketCount: function () {
        const model = $scope.model;
        return ctrl.cartService.events.getFullPriceEventTicketCount(model.eventId);
      },

      setMemberPriceOption: function (enabled: boolean) {
        ctrl.priceOptions[0].enabled = enabled;
      },

      isSelectedPriceOption: function (option) {
        return option && option === ctrl.selectedPriceOption;
      },

      validate: function () {
        const model = $scope.model;

        let error: {
          message: string;
          details: { errorText: string }[];
        } | null = null;

        ctrl.errors = [];

        if (model.reservationError) {
          error = {
            message: 'Requested tickets are not available.',
            details: [
              {
                errorText:
                  model.reservationError.requested + ' requested, ' + model.reservationError.available + ' available.',
              },
            ],
          };

          ctrl.errors.push(error);
        }

        if (model.hasTicketError) {
          error = {
            message: 'You must select at least one ticket.',
            details: [],
          };

          ctrl.errors.push(error);
        }

        if (model.restrictedEventError) {
          error = {
            message: 'Membership requirements for purchase of this event are not met.',
            details: [],
          };

          ctrl.errors.push(error);
        }
      },

      getRemainingPrices: function () {
        const model = $scope.model;
        const prices = model.event.priceList.prices.filter((priceListTicket) => {
          const cartTickets = model.tickets;
          let result = true;

          if (!priceListTicket.itemId) {
            const cartTicket = cartTickets.find((ticket) => {
              return ticket.ticketingTypeId === priceListTicket.personType.id;
            });

            priceListTicket.eventId = model.eventId;
            priceListTicket.ticketingTypeId = priceListTicket.personType.id;
            priceListTicket.ticketingTypeName = priceListTicket.personType.name;
            priceListTicket.name = priceListTicket.personType.name;
            priceListTicket.ticketingTypeDescription = priceListTicket.personType.description;
            priceListTicket.quantity = 0;
            priceListTicket.resolvedQuantity = 0;
            priceListTicket.isRetail = false;
            priceListTicket.itemType = 'Event';

            /**
             * Cart now returns discounted price (`unitPrice`) and retail price (`retailUnitPrice`)
             * for all ticket types when a coupon has been added to the cart.
             * @link https://acmeticketing.atlassian.net/browse/ENG-13483
             */
            const unitPrice = cartTicket ? cartTicket.unitPrice : priceListTicket.discountedPrice;
            const retailUnitPrice = cartTicket ? cartTicket.retailUnitPrice : priceListTicket.price;
            priceListTicket.unitPrice = unitPrice;
            priceListTicket.retailUnitPrice = retailUnitPrice;
          }

          for (let i = 0, ii = cartTickets.length; i < ii; i++) {
            if (cartTickets[i].ticketingTypeId === priceListTicket.ticketingTypeId) {
              result = false;
              break;
            }
          }
          return result;
        });

        model.event.morePrices = prices;
      },

      getRemainingAddons: function () {
        const model = $scope.model;
        const eventAddOns = model.event.addOns ? model.event.addOns.inventoryAddOns : [];
        const addOns = eventAddOns.filter((addOn) => {
          let result = true;
          const cartAddOns = model.addOns || [];

          if (!addOn.itemId) {
            addOn.eventId = model.eventId;
            addOn.inventoryId = addOn.id;
            addOn.inventoryName = addOn.name;
            addOn.unitPrice = addOn.price;
            addOn.amount = addOn.price;
            addOn.retailUnitPrice = addOn.price;
            addOn.quantity = 0;
            addOn.resolvedQuantity = 0;
            addOn.itemType = 'Inventory';
          }

          for (let i = 0, ii = cartAddOns.length; i < ii; i++) {
            if (cartAddOns[i].inventoryId === addOn.inventoryId) {
              result = false;
              break;
            }
          }
          return result;
        });

        model.event.moreAddOns = addOns;
      },

      processEventTimes: function (list) {
        const model = $scope.model;
        const times: TODO[] = [];

        angular.forEach(list, function (eventTime) {
          let listItem;
          const eventInCart = CartService.events.getById(eventTime.id);

          if (!eventInCart || model.eventId === eventTime.id) {
            listItem = {
              name: ctrl.getSlotTime(eventTime.startTime),
              startTime: eventTime.startTime,
              id: eventTime.id,
              availableTickets: eventTime.capacity - eventTime.soldQuantity,
              priceList: eventTime.priceList,
              addOns: eventTime.addOns,
            };

            times.push(listItem);

            if (eventTime.id === model.eventId) {
              ctrl.selectedEventTime = listItem;
            }
          }
        });

        return times;
      },

      getSlotTime: function (time) {
        return $filter('date')(CalendarService.parseDate(time), ctrl.standardTime);
      },

      hasAddOns: function () {
        const model = $scope.model;
        return model.event && model.event.addOns && model.event.addOns.inventoryAddOns.length;
      },

      changeEventTime: function (e, data) {
        const model = $scope.model;

        if (!ctrl.submitting) {
          if (data) {
            ctrl.selectedEventTime = data;
          }
          if (ctrl.selectedEventTime && ctrl.selectedEventTime.id) {
            ctrl.submitting = true;
            model.limitsChecked = false;
            SalesRulesService.resetLimits();
            CartService.events
              .switchEvent(model, ctrl.selectedEventTime)
              .then(ctrl.success.switchEvent)
              .catch(ctrl.error.switchEvent);
          }
        }
      },

      addTicket: function (ticket) {
        const model = $scope.model;
        model.tickets.push(ticket);
        model.tickets.push(angular.extend({}, ticket, { isRetail: true }));

        ctrl.cartService.events
          .addToCart(model)
          .then((response) => {
            ctrl.selectedTicketType = false;

            ctrl.getRemainingPrices();
            ctrl.checkDiscounts();
          })
          .catch((response) => {
            //do nothing?
          });
      },

      addAddOn: function (addOn) {
        const model = $scope.model;

        if (!model.addOns) {
          model.addOns = [];
        }
        model.addOns.push(addOn);

        ctrl.selectedAddOn = false;

        ctrl.getRemainingAddons();
      },

      checkDirty: function () {
        const model = $scope.model;
        let result = false;
        let item;

        for (let i = 0, ii = model.tickets.length; i < ii; i++) {
          item = model.tickets[i];

          if (item.quantity !== item.resolvedQuantity) {
            result = true;
            break;
          }
        }

        for (let i = 0, ii = (model.addOns || []).length; i < ii; i++) {
          item = model.addOns[i];

          if (item.quantity !== item.resolvedQuantity) {
            result = true;
            break;
          }
        }

        return result;
      },

      updateItem: function (item) {
        if (item.itemId) {
          if (ctrl.checkDirty()) {
            ctrl.submitting = true;
            CartService.events
              .updateItem(item)
              .then((response) => {
                item.resolvedQuantity = item.quantity;
                ctrl.success.updateItem(response);
              })
              .catch(ctrl.error.updateItem);
          }
        } else {
          if (ctrl.checkDirty()) {
            ctrl.submitting = true;
            CartService.events
              .addItem(item)
              .then((response) => {
                item.itemId = response.data.payload;
                item.resolvedQuantity = item.quantity;
                ctrl.success.addItem(response);
              })
              .catch(ctrl.error.addItem);
          }
        }
      },

      checkTicketLimits: function () {
        const model = $scope.model;
        ctrl.cartService.events
          .validateSalesRules(model)
          .then(() => {
            ctrl.setTicketLimits();
          })
          .catch(() => {
            //TODO: Show error?
          });
      },

      validateTicketLimits: function () {
        const model = $scope.model;
        const sameDayEventTickets = ctrl.cartService.events.getSameDayEventTicketQuantities();

        if (sameDayEventTickets || (model.limitsChecked && !model.hasLimits && !model.hasSalesRuleRestriction)) {
          model.limitsChecked = false;
        } else {
          SalesRulesService.updateTicketLimits(model, sameDayEventTickets);
        }
      },

      hasLimitErrors: function (discounted) {
        const model = $scope.model;
        let result = false;
        let tickets: TODO[] = [];

        if (!ctrl.getTicketLimitOverride()) {
          tickets = model.tickets.filter((ticket) => {
            const isDiscounted = ctrl.isTicketDiscounted(ticket);
            return (discounted && isDiscounted) || (!discounted && !isDiscounted);
          });

          for (let i = 0, ii = tickets.length; i < ii; i++) {
            result = tickets[i].limitExceeded;
            if (result) {
              break;
            }
          }
        }

        return result;
      },

      toggleTicketLimitOverride: function () {
        const model = $scope.model;
        model.ignoreLimits = !model.ignoreLimits;

        ctrl.cartService.events
          .updateTicketLimitExceptions(model)
          .then(ctrl.success.updateTicketLimitExceptions)
          .catch(ctrl.error.updateTicketLimitExceptions);
      },

      toggleSalesRuleOverride: function () {
        const model = $scope.model;
        model.ignoreLimits = !model.ignoreLimits;

        ctrl.cartService.events
          .updateTicketLimitExceptions(model)
          .then(ctrl.success.updateTicketLimitExceptions)
          .catch(ctrl.error.updateTicketLimitExceptions);
      },

      getTicketLimitOverride: function () {
        const model = $scope.model;
        return model.ignoreLimits;
      },

      getSalesRuleOverride: function () {
        const model = $scope.model;
        return model.ignoreLimits;
      },

      showMemberRestrictions: function () {
        const restrictionModal = $uibModal.open({
          size: 'md',
          controller: 'ConfirmModalController',
          templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
          resolve: {
            modalTitle: () => {
              return 'Membership Restrictions';
            },
            okText: () => {
              return 'OK';
            },
            modalMessage: () => {
              const model = $scope.model;
              let message =
                  'This event is restricted to certain members.' +
                  '<br> Please view the event template for more details on which membership levels are allowed to purchase this event.',
                membershipLevels = model.event.memberRestriction.membershipLevels || [];
              if (membershipLevels.length) {
                membershipLevels = membershipLevels.map((membershipLevel) => {
                  return membershipLevel.name || '';
                });
                message = 'This event is restricted to members of the following membership levels: <br><br>';
                message = message + membershipLevels.join('<br>');
              }
              return message;
            },
          },
        });

        restrictionModal.result
          .then(() => {
            //do nothing
          })
          .catch(() => {
            // Do nothing
          });
      },

      success: {
        updateItem: function (response) {
          ctrl.submitting = false;
          ctrl.validateTicketLimits();
        },

        addItem: function (response) {
          ctrl.submitting = false;
          ctrl.validateTicketLimits();
        },

        getEventTimes: function (response) {
          ctrl.eventTimes = response.data.payload.list;
          ctrl.availableEventTimes = ctrl.processEventTimes(ctrl.eventTimes);
          ctrl.validate();
          ctrl.eventTimesLoading = false;
        },
        switchEvent: function (response) {
          ctrl.submitting = false;
          ctrl.validateTicketLimits();
          $scope.$emit('Cart::Refresh');
          $rootScope.$broadcast('Cart::CouponRefresh');
        },

        updateTicketLimitExceptions: function () {
          ctrl.validateTicketLimits();
        },
      },

      error: {
        updateItem: function (response) {
          ctrl.submitting = false;
          ctrl.errors = [{ message: response.data.error }];
          ctrl.validateTicketLimits();
        },

        addItem: function (response) {
          ctrl.submitting = false;
          ctrl.errors = [{ message: response.data.error }];
          ctrl.validateTicketLimits();
        },

        getEventTimes: function (response) {
          ctrl.eventTimesLoading = false;
        },
        switchEvent: function (response) {
          ctrl.submitting = false;
          ctrl.errors = [{ message: response.data.error }];
          ctrl.validateTicketLimits();
        },
        updateTicketLimitExceptions: function (response) {
          ctrl.errors = [{ message: response.data.error }];
          ctrl.validateTicketLimits();
        },
      },

      onSumUpdateTotal: function (e, data) {
        ctrl.setTicketLimits();
      },

      onItemCountUpdated: function (n, o) {
        ctrl.refresh();
      },

      onSelect: function (e, data, index) {
        if (ctrl.selectedTicketType && ctrl.selectedTicketType.ticketingTypeId) {
          ctrl.addTicket(ctrl.selectedTicketType);
        }
      },

      onSelectAddOn: function (e, data, index) {
        if (ctrl.selectedAddOn && ctrl.selectedAddOn.inventoryId) {
          ctrl.addAddOn(ctrl.selectedAddOn);
        }
      },

      onDateFormatLoad: function (e, data) {
        ctrl.standardTime = UserPreferencesService.getDateFormat('standardTime', 'hourFormat');
      },

      onCartOrganizationUpdate: function (newValue, oldValue) {
        if (newValue && newValue.id) {
          ctrl.organization = ctrl.cartService.getOrganization();
        }
      },
    };

    $scope.cartItemEvent = ctrl;
    ctrl.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/cartItem/event/event.tpl.html',
    scope: {
      model: '=',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: CartItemEventController,
  };
}

export const CartItemEventDirectiveModule = angular
  .module('acme.common.directive.cartItem.event', [
    'ui.bootstrap',
    'acme.common.directive.sum',
    'acme.common.directive.switcher',
    'acme.common.directive.combobox',
    CartServiceModule,
    'acme.common.service.calendar',
    'acme.common.service.userPreferences',
    'acme.common.service.helpers',
    'acme.common.service.salesRules',
    'acme.common.service.api',
    'acme.view.application.membership.detail.datePicker.controllers',
    'acme.view.application.modals.confirm.controllers',
  ])
  .directive('cartItemEvent', CartItemEventDirective).name;
